import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../Common/InputText';

export const AccountDetailsSection = (props) => {
    const onChange = (e) => {
        props.onFormChange(e.target.name, e.target.value);
    }

    const className = props.isFormValid ? "account-details-form" : "account-details-form was-validated"
    return (
        <div className="account-details-section section">
            <form className={className} noValidate>
                <div className="row content">
                    <div className="col-12 col-sm-4 header">
                        <h4>Account Details</h4>
                        <p>This information will be used to identify you to your teammates</p>
                    </div>
                    <div className="col-12 col-sm-8 fields">
                        <div className="row">
                            <InputText bootstrapClass="col-12 col-sm-6" name="firstName" label="First Name" placeholder="First Name" type="text" value={props.user.firstName} onChange={onChange} isRequired={true} errorMessage="First Name is required" />
                            <InputText bootstrapClass="col-12 col-sm-6" name="lastName" label="Last Name" placeholder="Last Name" type="text" value={props.user.lastName} onChange={onChange} isRequired={true} errorMessage="Last Name is required" />
                        </div>
                        <div className="row">
                            <InputText bootstrapClass="col-12 col-sm-6" name="email" label="Email" placeholder="Email" type="text" value={props.user.email} onChange={onChange} isRequired={true} errorMessage="Email is required" />
                            <InputText bootstrapClass="col-12 col-sm-6" name="userName" label="UserName" placeholder="UserName" type="text" value={props.user.userName} onChange={onChange} isRequired={true} errorMessage="UserName is required" isDisabled={props.user.isSSOUser} />
                        </div>
                        <div className="row">
                            <InputText bootstrapClass="col-12 col-sm-6" name="workPhone" label="Work Phone" placeholder="Work Phone" type="text" value={props.user.workPhone} onChange={onChange} />
                            <InputText bootstrapClass="col-12 col-sm-6" name="jobTitle" label="Job Title" placeholder="Job Title" type="text" value={props.user.jobTitle} onChange={onChange} isRequired={true} errorMessage="Job Title is required" />
                            {
                                props.user.isSSOUser 
                                ?
                                <InputText bootstrapClass="col-12 col-sm-6" name="ssoId" label="SSO ID" placeholder="SSO ID" type="text" value={props.user.ssoId} onChange={onChange} isDisabled={true} />
                                :
                                <InputText bootstrapClass="col-12 col-sm-6" name="employeeId" label="Employee ID" placeholder="Employee ID" type="text" value={props.user.employeeId} onChange={onChange} />
                            }
                        </div>
                    </div>
                </div>
            </form>
            <div className="footer">
                <button name="accountDetailsSaveButton" className="btn btn-primary save-changes" onClick={props.onSaveChanges}>Save Changes</button>
            </div>
        </div>
    );
}

AccountDetailsSection.propTypes = {
    user: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onFormChange: PropTypes.func.isRequired,
    onSaveChanges: PropTypes.func.isRequired
};

export default AccountDetailsSection;

